export class EntTransportFilter {
  page: number;
  size: number;
  year: string  | null;
  periodStart: string  | null;
  periodEnd: string  | null;
  territorialUnitIds: number[]  | null;
  territorialUnitId: number  | null;
  checkStatus: boolean | null;
  seasonStatus: boolean | null;
  manufactureYear: number  | null;
  transportTypeName: string  | null;
  typeIds: number[]  | null;
  transportCategoryId: number  | null;
  statusIds: number[]  | null;
  governmentIds: number[]  | null;
  
  constructor(init?:Partial<EntTransportFilter>) {
    this.manufactureYear = null;
    this.transportTypeName = null;
    this.territorialUnitIds = null;
    this.territorialUnitId = null;
    this.typeIds = null;
    this.year = null;
    this.periodStart = null;
    this.periodEnd = null;
    this.transportCategoryId = null;
    this.statusIds = null;
    this.statusIds = null;
    this.governmentIds = null;
    this.seasonStatus = null;
    this.checkStatus = null;
    this.page = 1;
    this.size = 200;
    if(init){
      Object.assign(this, init)
    }
  }
}

